import { IDropdown } from "shared"
import { IDataApiFields } from "../models/IDataApiFields";

export interface IFieldFormExternal {
    id: "itemformCity" | "dateYear" | "dateMonth" | "codeDane" | "names" | "role"  | "emailUser" | "confirmEmail" | "phone";
    name: string;
    type: string;
    label: string;
    placeholder: string;
    testId: string;
    isEnable?: boolean;
    required?: boolean;
    options?: IDropdown[];
}

export const fieldFormExternal = (optionsDropdowns?: IDataApiFields): IFieldFormExternal[] => {
    return[
        {
            id: "itemformCity",
            name: "itemformCity",
            type: "select",
            label: "Por favor seleccione el Municipio",
            placeholder: "Municipio",
            required: true,
            testId: "itemformCity",
            options: optionsDropdowns?.cities
        },
        {
            id: "codeDane",
            name: "codeDane",
            type: "text",
            label: "Código DANE",
            placeholder: "Código DANE",
            required: true,
            testId: "codeDane"  
        },
        {
            id: "dateYear",
            name: "dateYear",
            type: "select",
            label: "Por favor seleccione Año",
            placeholder: "Año",
            testId: "dateYear",
            required: true,
            options: optionsDropdowns?.responseYear
        },
        {
            id: "dateMonth",
            name: "dateMonth",
            type: "select",
            label: "Por favor seleccione el Mes",
            placeholder: "Mes",
            testId: "dateMonth",
            required: true,
            options: optionsDropdowns?.responseMonth
        },
    ]
}

export const fieldFormInfoEmployee = (): IFieldFormExternal[] => {
    return[
        {
            id: "names",
            name: "names",
            type: "text",
            label: "Nombres y Apellidos",
            placeholder: "Nombres y Apellidos",
            testId: "names",
            required: true,
            isEnable: true,
        },
        {
            id: "role",
            name: "role",
            type: "text",
            placeholder: "Cargo o Rol",
            label: "Cargo o Rol",
            testId: "role",
            required: true,
        },
        {
            id: "emailUser",
            name: "emailUser",
            type: "text",
            placeholder: "Correo Electrónico",
            label: "Correo Electrónico",
            testId: "emailUser",
            required: true,
        },
        {
            id: "confirmEmail",
            name: "confirmEmail",
            type: "text",
            placeholder: "Confirmar Correo Electrónico",
            label: "Confirmar Correo Electrónico",
            testId: "confirmEmail",
            required: true,
        },
        {
            id: "phone",
            name: "phone",
            type: "text",
            placeholder: "Teléfono o Celular",
            label: "Teléfono o Celular",
            testId: "phone",
            required: true,
        },
    ]
}